import { useMemo } from 'react';
import { useModal } from '@ebay/nice-modal-react';
import { ColumnDef } from '@tanstack/react-table';
import { Hash, Logs, PhoneOutgoing, User } from 'lucide-react';
import { useNavigate } from 'react-router';
import { ICall } from '@/types';
import PaginatedDataTable from '../DataTable/PaginatedDataTable';
import Section from '../Section';
import Time from '../Time';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';

const Calls = () => {
  const navigate = useNavigate();
  const drawer = useModal('call-drawer');
  const contactDrawer = useModal('show-contact-drawer');

  const columns: ColumnDef<ICall>[] = useMemo(
    () => [
      {
        accessorKey: 'id',
        header: 'Call',
        cell: ({ row }) => {
          return (
            <>
              <Button
                variant={'outline'}
                className="py-1.5 rounded-full px-2 text-sm cursor-pointer"
                onClick={() => {
                  drawer.show({ callId: row.original.id });
                }}
              >
                <div className="flex items-center gap-1">
                  <Hash />
                  {row.original.id}
                </div>
              </Button>
            </>
          );
        },
      },
      {
        accessorKey: 'contact.name',
        header: 'Contact',
        cell: ({ row }) => {
          const contact = row.original.contact;
          return contact ? (
            <Button
              variant="outline"
              className="py-1.5 rounded-full px-2 text-sm cursor-pointer"
              onClick={() => contactDrawer.show({ contactId: contact.id })}
            >
              <div className="flex items-center gap-1">
                <User />
                {contact.name}
              </div>
            </Button>
          ) : (
            <div className="italic text-gray-500">No contact</div>
          );
        },
      },
      {
        accessorKey: 'campaign.name',
        header: 'Campaign',
        cell: ({ row }) => {
          const campaign = row.original.campaign;
          return campaign ? (
            <Button
              variant="outline"
              className="py-1.5 rounded-full px-2 text-sm cursor-pointer"
              onClick={() => navigate(`/campaigns/${campaign.id}`)}
            >
              <div className="flex items-center gap-1">
                <PhoneOutgoing />
                {campaign.name}
              </div>
            </Button>
          ) : (
            <div className="italic text-gray-500">No campaign</div>
          );
        },
      },
      {
        accessorKey: 'status',
        header: 'Status',
        cell: ({ row }) => <Badge>{row.original.status}</Badge>,
      },
      {
        accessorKey: 'call_started_at',
        header: 'Called',
        cell: ({ row }) => <Time>{row.original.call_started_at}</Time>,
      },
    ],
    [],
  );

  return (
    <>
      <div className="flex items-center justify-between gap-2 mb-8">
        <div className="flex items-center gap-2 mb-4 ">
          <Logs />
          <div className="text-lg font-bold">Call History</div>
        </div>
      </div>

      <Section>
        <PaginatedDataTable url={'/v1/calls'} columns={columns} />
      </Section>
    </>
  );
};

export default Calls;
